import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=f9048cea&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9048cea')) {
      api.createRecord('f9048cea', component.options)
    } else {
      api.reload('f9048cea', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=f9048cea&", function () {
      api.rerender('f9048cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8RWzUnBTxZfWp/JS/imageCarousel.vue"
export default component.exports